var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDepartmentsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6242 0.00781473 23.9922 5.37582 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM2.18168 12C2.18168 17.4224 6.57743 21.8182 11.9999 21.8182C17.4198 21.8122 21.812 17.4199 21.818 12C21.818 6.57757 17.4223 2.18182 11.9999 2.18182C6.57743 2.18182 2.18168 6.57757 2.18168 12Z",
    fill: "#3030AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9092 4.36361C10.9092 3.76112 11.3976 3.27271 12.0001 3.27271C16.82 3.27271 20.7274 7.18004 20.7274 12C20.7274 16.8199 16.82 20.7272 12.0001 20.7272C11.3976 20.7272 10.9092 20.2388 10.9092 19.6363V4.36361ZM18.5513 12C18.5513 8.8037 16.2429 6.07486 13.0908 5.54506V18.4549C16.2429 17.9251 18.5513 15.1962 18.5513 12Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDepartmentsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/departmentsIcon.7cb00e700b9493a56d87e3f8e468cd73.svg";